import { CommonModule } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Inject, OnInit, Renderer2, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { EncrDecrService } from '@mysrc/app/Providers/EncrDecrService';
import { CommonService } from '../../services/commonservice';
import { FormFieldModule } from '@progress/kendo-angular-inputs';
import { API_ENDPOINTS } from '@mysrc/app/api-endpoints';
import { BaseHttpReqRespService } from '@mysrc/app/modules/fwcore/services';
import { OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'create-desc-input',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, CommonModule, FormFieldModule],
  templateUrl: './page-create-desc-input.component.html',
  styleUrl: './page-create-desc-input.component.scss',
  providers: [CommonService]
})

export class PageCreateDescInputComponent extends BaseHttpReqRespService implements OnInit {
  QUESTION_ENDPOINT = API_ENDPOINTS.QUESTION;
  SURVEY_ENDPOINT = API_ENDPOINTS.SURVEY;
  public folderName!: string;
  questionDescriptionForm!: FormGroup;
  myAppUrl: any;
  questionlist: any;
  QuestionId: any;
  successOrFailureMessage: string = '';
  public questionId!: number;
  public folderId!: number;
  http!: HttpClient;
  @ViewChild('CreateCategoryModal') categoryModal!: TemplateRef<any>;


  quesCategoryForm!: FormGroup;
  public questionCategoryList: questionCategory[] = [];
  public questionCategoryId: number = 0;
  public redirectedSectionId!: number;
  public redirectedSurveyId!: number;


  constructor(
    http: HttpClient,
    private _router: Router,
    _http: HttpClient,
    @Inject('BASE_URL') baseUrl: string,
    @Inject(OKTA_AUTH) private oauth: OktaAuth,
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    private route: ActivatedRoute,
    private renderer: Renderer2,
    private EncrDecr: EncrDecrService,
    private modalService: NgbModal,
    @Inject('CONFIG_SETTINGS') configSettings: any) {
    super(http, oauth);
    const genSettings = configSettings[<any>'general'];
    this.baseUrl = genSettings[<any>'adminApiUrl'];
    this.myAppUrl = this.baseUrl;
  }

  BackUrl() {
    var location = window.location.pathname;
    if (location.includes("/client") == false) {
      let fId = this.folderId;
      let fName = this.folderName;
      if (fId > 0)
        this._router.navigate(['viewquestions'], { queryParams: { questionReference: fId, question: fName } });
      else
        this._router.navigate(['question']);
    }
    else {
      this._router.navigate(['programoverview']);
    }
  }

  ngOnInit() {
    this.questionDescriptionForm = this.formBuilder.group({
      questionDescription: ['', [Validators.required]],
      questionCategoryId: new FormControl(''),
      shortName: new FormControl(''),
      maxCharacterLength: new FormControl('')
    });
    this.questionId = + this.route.snapshot.queryParams["questionId"];
    this.folderId = + this.route.snapshot.queryParams["folderId"];
    this.redirectedSectionId = this.route.snapshot.queryParams["redirectedSectionId"];
    this.redirectedSurveyId = this.route.snapshot.queryParams["redirectedSurveyId"];
    this.getDescriptionQuestionDeatils(this.questionId, this.folderId);
    this.folderName = this.folderName;
    this.quesCategoryForm = this.formBuilder.group({
      'quesCategoryName': new FormControl(null, Validators.required)
    });

    this.getQuestionCategoryList();
  }

  getQuestionCategoryList() {
    this.commonService.httpGet("", this.myAppUrl + '/' + this.QUESTION_ENDPOINT.QUESTION_CATEGORY_LIST).subscribe(result => {
      this.questionCategoryList = result;
    }, error => console.error(error));

  }

  AddQuesCategory() {
    let tmpQuesCategoryName = this.quesCategoryForm.get('quesCategoryName')?.value;
    let resourceIdList = "quesCategoryName=" + tmpQuesCategoryName;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
      })
    };

    this.commonService.httpPost(resourceIdList, this.myAppUrl + '/' + this.QUESTION_ENDPOINT.SAVE_CATEGORY, httpOptions).subscribe(result => {
      this.getQuestionCategoryList();
    }, error => console.error(error));
  }

  ResetQuesCategoryForm() {
    this.quesCategoryForm.reset();
  }

  getDescriptionQuestionDeatils(questionId: any, folderId: any) {

    let parameter = "?questionId=" + questionId + "&folderId=" + folderId;
    this.commonService.httpGet("", this.myAppUrl + '/' + this.QUESTION_ENDPOINT.DETAILS + parameter)
      .subscribe(response => {
        this.folderName = response.folderName;
        this.questionDescriptionForm.patchValue({
          questionDescription: response.question,
          questionCategoryId: response.questionCategoryId,
          shortName: response.shortName,
          maxCharacterLength: response.maxCharacterLength,
        });

      }, error => {

        console.log(error);
      });
  }

  public saveQuestionDescription() {

    let questionId = + this.route.snapshot.queryParams["questionId"]
    let folderId = + this.route.snapshot.queryParams["folderId"];
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
    // Build the JSON payload
    const payload = {
      question: this.questionDescriptionForm.value.questionDescription,
      questionCategoryId: this.questionDescriptionForm.controls.questionCategoryId.value,
      shortName: this.questionDescriptionForm.controls.shortName.value,
      maxCharacterLength: this.questionDescriptionForm.controls.maxCharacterLength.value,
      createdBy: this.EncrDecr.get(localStorage.getItem('userId') || ''),
      questionId: questionId,
      folderId: folderId
    };
    this.commonService.httpPostWOHeader(this.myAppUrl + '/' + this.QUESTION_ENDPOINT.SAVE_DESCRIPTION, JSON.stringify(payload), httpOptions).subscribe(questionId => {
      this.successOrFailureMessage = "Destription Type Question Saved Successfully";
      setTimeout(() => {
        this.successOrFailureMessage = '';
        this.folderId = + this.route.snapshot.queryParams["folderId"];
        this.folderName = this.route.snapshot.queryParams["folderName"];
        this.redirectedSectionId = this.route.snapshot.queryParams["redirectedSectionId"];
        this.redirectedSurveyId = this.route.snapshot.queryParams["redirectedSurveyId"];
        var location = window.location.pathname;
        if (location.includes("/client") == false) {
          if (this.redirectedSectionId >= 0 && this.redirectedSurveyId >= 0) {
            this.mapQuestionsToSection(questionId, this.redirectedSurveyId, this.redirectedSectionId)
            this._router.navigate(['/survey-questionnaire'], { queryParams: { 'surveyId': this.redirectedSurveyId, 'sectionId': this.redirectedSectionId } });
          } else {
            if (this.folderId > 0)
              this._router.navigate(['viewquestions'], { queryParams: { questionReference: this.folderId, question: this.folderName } });
            else
              this._router.navigate(['question']);
          }
        }
        else {
          if (this.redirectedSectionId >= 0 && this.redirectedSurveyId >= 0) {
            this.mapQuestionsToSection(questionId, this.redirectedSurveyId, this.redirectedSectionId)
            this._router.navigate(['/clientadmin-survey-questionnaire'], { queryParams: { 'surveyId': this.redirectedSurveyId, 'sectionId': this.redirectedSectionId } });
          } else {
            if (this.folderId > 0)
              this._router.navigate(['viewquestions'], { queryParams: { questionReference: this.folderId, question: this.folderName } });
            else
              this._router.navigate(['question']);
          }
        }
      }, 2000);



    }, error => console.error(error));
  }
  mapQuestionsToSection(questionid: any, surveyId: any, currentSectionId: any) {
    var concatenated = questionid.toString();

    let questionIdList = "questionIdList=" + concatenated + "&surveyId=" + surveyId + "&sectionId=" + currentSectionId;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
      })
    };

    this.commonService.httpPost(questionIdList, this.myAppUrl + '/' + this.SURVEY_ENDPOINT.MAP_QUESTION_TO_SECTION, httpOptions).subscribe(result => {
      window.setTimeout(() => {
        this.successOrFailureMessage = '';
      }, 1200);
    }, error => console.error(error));

  }
  BackToSectionUrl() {
    var location = window.location.pathname;
    if (location.includes("/client") == false) {
      if (this.redirectedSectionId >= 0 && this.redirectedSurveyId >= 0) {
        this._router.navigate(['/survey-questionnaire'], { queryParams: { 'surveyId': this.redirectedSurveyId, 'sectionId': this.redirectedSectionId } });
      }
    }
    else {
      this._router.navigate(['/clientadmin-survey-questionnaire'], { queryParams: { 'surveyId': this.redirectedSurveyId, 'sectionId': this.redirectedSectionId } });

    }
  }
  openCategoryModal() {
    if (this.categoryModal) {
      this.modalService.open(this.categoryModal);
    }
  }
}

interface questionCategory {
  questionCategoryId: number;
  questionCategoryName: string;
}

